/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseCalcFieldAggregate } from './DatabaseCalcFieldAggregate';
import {
    DatabaseCalcFieldAggregateFromJSON,
    DatabaseCalcFieldAggregateFromJSONTyped,
    DatabaseCalcFieldAggregateToJSON,
} from './DatabaseCalcFieldAggregate';

/**
 * 
 * @export
 * @interface DatabaseCalcFieldToken
 */
export interface DatabaseCalcFieldToken {
    /**
     * 
     * @type {string}
     * @memberof DatabaseCalcFieldToken
     */
    type?: DatabaseCalcFieldTokenTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DatabaseCalcFieldToken
     */
    value?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseCalcFieldToken
     */
    ohneLeerzeichen?: boolean;
    /**
     * 
     * @type {DatabaseCalcFieldAggregate}
     * @memberof DatabaseCalcFieldToken
     */
    aggregate?: DatabaseCalcFieldAggregate;
}


/**
 * @export
 */
export const DatabaseCalcFieldTokenTypeEnum = {
    Constant: 'CONSTANT',
    Field: 'FIELD',
    Operator: 'OPERATOR',
    Aggregate: 'AGGREGATE'
} as const;
export type DatabaseCalcFieldTokenTypeEnum = typeof DatabaseCalcFieldTokenTypeEnum[keyof typeof DatabaseCalcFieldTokenTypeEnum];


/**
 * Check if a given object implements the DatabaseCalcFieldToken interface.
 */
export function instanceOfDatabaseCalcFieldToken(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseCalcFieldTokenFromJSON(json: any): DatabaseCalcFieldToken {
    return DatabaseCalcFieldTokenFromJSONTyped(json, false);
}

export function DatabaseCalcFieldTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseCalcFieldToken {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'ohneLeerzeichen': !exists(json, 'ohneLeerzeichen') ? undefined : json['ohneLeerzeichen'],
        'aggregate': !exists(json, 'aggregate') ? undefined : DatabaseCalcFieldAggregateFromJSON(json['aggregate']),
    };
}

export function DatabaseCalcFieldTokenToJSON(value?: DatabaseCalcFieldToken | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'value': value.value,
        'ohneLeerzeichen': value.ohneLeerzeichen,
        'aggregate': DatabaseCalcFieldAggregateToJSON(value.aggregate),
    };
}

